import React from 'react';
import { Li, Ul } from 'src/ui/list';
import { InternalLink } from 'src/ui/link';
import { P, Strong } from 'src/ui/text';
import { StyledUl } from './styles';
import { useAppContext } from '@prisjakt/ui-app-context';
import { H4Text } from '@prisjakt/ui/text/variants';
import { ProductDescription as ProductDescriptionType } from 'src/types';

export const ProductDescription: React.FC<ProductDescriptionProps> = ({
  description,
}) => {
  const { preamble, descriptionPoints, articles } = description;
  const { t } = useAppContext();
  return (
    <div>
      {preamble && <P>{preamble}</P>}
      {descriptionPoints && descriptionPoints?.length > 0 && (
        <StyledUl>
          {descriptionPoints.filter(Boolean).map(point => (
            <Li key={point!.title}>
              <Strong>{point!.title}</Strong>
              <P>{point!.text}</P>
            </Li>
          ))}
        </StyledUl>
      )}
      {articles && articles?.length > 0 && (
        <>
          <H4Text container={Strong}>{t('common', 'article.articles')}</H4Text>
          <Ul>
            {articles.filter(Boolean).map(article => {
              const url = new URL(article!.url!).pathname;

              return (
                <Li key={url}>
                  <InternalLink to={url}>{article!.name}</InternalLink>
                </Li>
              );
            })}
          </Ul>
        </>
      )}
    </div>
  );
};

interface ProductDescriptionProps {
  description: ProductDescriptionType;
}
